import { ContentSuggest } from './ContentSuggest';

export interface ContentSuggestResponse {
  content: ContentSuggest;
}

export function isContentSuggestResponse(response: unknown): response is ContentSuggestResponse {
  const instantSearchResponse = response as ContentSuggestResponse;
  return instantSearchResponse.content !== undefined;
}
